export default "__VITE_ASSET__W9n9HB6L__"